// Internationalization module
import en from './en.js'
import fr from './fr.js'
import de from './de.js'
import es from './es.js'
import it from './it.js'
import pl from './pl.js'

const translations = { en, fr, de, es, it, pl }

// Language metadata with flags
export const languages = [
  { code: 'en', name: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'fr', name: 'Francais', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'de', name: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'es', name: 'Espanol', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'it', name: 'Italiano', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'pl', name: 'Polski', flag: '\u{1F1F5}\u{1F1F1}' }
]

class I18n {
  constructor() {
    this.locale = 'en'
  }

  setLocale(locale) {
    if (translations[locale]) {
      this.locale = locale
    }
  }

  t(key, params = {}) {
    const translation = translations[this.locale]?.[key] || translations.en[key] || key

    // Simple parameter substitution
    return translation.replace(/\{(\w+)\}/g, (match, param) => {
      return params[param] !== undefined ? params[param] : match
    })
  }

  getLocale() {
    return this.locale
  }

  getAvailableLocales() {
    return Object.keys(translations)
  }

  getLanguages() {
    return languages
  }
}

export const i18n = new I18n()
export default i18n
